import React from "react";
import BBCode from "bbcode-parser/parser";
import locale from "../../locale";

class LayoutInformation extends React.Component
{
	constructor(props, context)
	{
		super(props, context);

		this.bbCodeParser = BBCode['default'];


		this.state = {
			text: '',
		};
	}

	componentDidMount()
	{
		const {event} = this.props;
		const text = locale.getProperty(event.moduleInformation, 'text');
		this.setState({text});
	}

	render()
	{
		let {text} = this.state;
		const {settings} = this.props;

		if (!settings) {
			return null;
		}

		if (!text) {
			return null;
		}

		text = this.bbCodeParser.parse(text || '');

		return (
			<aside id="information" style={settings.style}>
				<h1>{locale.getProperty(settings, 'title') || locale.get('layer-information-title')}</h1>
				<div dangerouslySetInnerHTML={{__html: text}} className="landing-nav-section-text" style={settings.styleContent} />
			</aside>
		);
	}
}

export default LayoutInformation;
